import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function Topbar({ collapsed, title }: { collapsed: boolean; title?: string }) {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();
  const [dropOpen, setDropOpen] = useState(false);
  const dropRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handler(e: MouseEvent) {
      if (dropRef.current && !dropRef.current.contains(e.target as Node)) setDropOpen(false);
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/superadmin/login', { replace: true });
  };

  const initials = admin?.full_name
    ? admin.full_name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : admin?.email?.slice(0, 2).toUpperCase() || 'AD';

  return (
    <header
      ref={dropRef}
      style={{
        height: 56, background: '#ffffff', borderBottom: '1px solid #e8edf4',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 20px', flexShrink: 0, position: 'relative',
      }}
    >
      <div>
        {title && <p style={{ fontWeight: 800, fontSize: 14, color: '#003c6c ' }}>{title}</p>}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* <button
          style={{
            width: 34, height: 34, borderRadius: 8, border: '1px solid #e8edf4',
            background: '#f8fafc', color: '#6b7280',
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
          }}
        >
          <i className="ti ti-bell" style={{ fontSize: 16 }} aria-hidden="true" />
        </button> */}

        <button
          onClick={() => setDropOpen(!dropOpen)}
          style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '4px 10px 4px 5px', borderRadius: 9,
            border: '1px solid #e8edf4', background: '#f8fafc', cursor: 'pointer',
          }}
        >
          <div style={{
            width: 28, height: 28, borderRadius: '50%',
            background: 'linear-gradient(135deg, #0d9488, #0f766e)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 10, fontWeight: 900, color: '#fff', flexShrink: 0,
          }}>
            {initials}
          </div>
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontSize: 12, fontWeight: 700, color: '#1f2937', lineHeight: 1, maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {admin?.full_name || admin?.email}
            </p>
            <p style={{ fontSize: 10, color: '#9ca3af', marginTop: 1 }}>Administrator</p>
          </div>
          <i className={`ti ${dropOpen ? 'ti-chevron-up' : 'ti-chevron-down'}`} style={{ fontSize: 12, color: '#9ca3af', marginLeft: 2 }} />
        </button>

        {dropOpen && (
          <div style={{
            position: 'absolute', top: 62, right: 16, width: 200,
            background: '#fff', border: '1px solid #e5e7eb',
            borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
            padding: '6px 0', zIndex: 50,
          }}>
            <div style={{ padding: '10px 16px', borderBottom: '1px solid #f3f4f6' }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {admin?.full_name}
              </p>
              <p style={{ fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {admin?.email}
              </p>
            </div>
            <button
              onClick={handleLogout}
              style={{
                display: 'flex', alignItems: 'center', gap: 10, padding: '9px 16px',
                fontSize: 12, fontWeight: 500, color: '#ef4444',
                background: 'transparent', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left',
              }}
            >
              <i className="ti ti-logout" style={{ fontSize: 15 }} aria-hidden="true" />
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
